"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactD3Speedometer = _interopRequireDefault(require("react-d3-speedometer"));

require("./styles.css");

var _segmentsUtils = require("./segments-utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SpeedometerPartie = function SpeedometerPartie(props) {
  var partie = props.partie,
      completed = props.completed,
      defaultSegmentColors = props.defaultSegmentColors,
      propsChildsComponent = props.propsChildsComponent;

  var _get_segments_by_eval = (0, _segmentsUtils.get_segments_by_eval)(partie.evaluations, defaultSegmentColors),
      _get_segments_by_eval2 = _slicedToArray(_get_segments_by_eval, 2),
      segmentByEvalRange = _get_segments_by_eval2[0],
      segmentColorsByEvalRange = _get_segments_by_eval2[1]; // graph : "segment-value"
  // affichage qui mériterait un component à part
  // surcharge complètement les réglages du dessus
  // affiche le mode "current value" de speedometer
  // il n'y a que 2 segments colorés, à la taille du pourcentage
  // pas indexé sur les ranges définis


  var _ref = partie.graph || "segment-range",
      type = _ref.type;

  if (type === "segment-value") {
    segmentByEvalRange = [0, partie.percent, 100];
    segmentColorsByEvalRange = ["#a3be8c", "#bf616a"];
  }

  var textColor = propsChildsComponent.textColor,
      textColorUseScore = propsChildsComponent.textColorUseScore;
  textColor = textColorUseScore ? partie.evaluation.color : textColor;
  return _react["default"].createElement("div", {
    className: "container-evaluation-partie"
  }, _react["default"].createElement("div", {
    className: "container-speedometer col-chart-partie"
  }, _react["default"].createElement(_reactD3Speedometer["default"], {
    fluidWidth: true,
    maxValue: 100,
    value: partie.percent,
    maxSegmentLabels: 0,
    customSegmentStops: segmentByEvalRange,
    segmentColors: segmentColorsByEvalRange,
    currentValueText: "".concat(partie.percent, "%") // ringWidth={40}
    // needleColor="#333"
    ,
    valueTextFontSize: "".concat(propsChildsComponent.valueTextFontSize),
    paddingVertical: propsChildsComponent.paddingVertical,
    textColor: textColor // exemple par défaut, sans tenir compte des ranges et couleurs fournies
    // customSegmentStops={[0, 40, 60, 80, 100]}
    // segmentColors={["#bf616a", "#d08770", "#ebcb8b", "#a3be8c"]}

  })), _react["default"].createElement("div", {
    className: "col-eval-partie",
    style: {
      width: "100%"
    }
  }, _react["default"].createElement("h4", null, partie.label), _react["default"].createElement("div", {
    className: "score"
  }, "Score: ", partie.percent, "%"), completed && _react["default"].createElement("div", {
    className: "evaluation-partie",
    dangerouslySetInnerHTML: {
      __html: partie.evaluation.reco
    }
  })));
};

var _default = SpeedometerPartie;
exports["default"] = _default;